(function () {
  function initCarousel(root) {
    if (!root || root.getAttribute('data-carousel-ready') === 'true') return;

    var track = root.querySelector('[data-packside-carousel-track]');
    var previous = root.querySelector('[data-packside-carousel-prev]');
    var next = root.querySelector('[data-packside-carousel-next]');
    if (!track) return;

    var items = [];
    var index = 0;
    var timer = null;
    var scrollFrame = null;
    var isRtl = false;
    var suppressClick = false;
    var dragThreshold = 10;
    var drag = {
      active: false,
      pointerId: null,
      startX: 0,
      lastX: 0,
      moved: false,
    };

    root.setAttribute('data-carousel-ready', 'true');

    function refreshItems() {
      items = Array.prototype.slice.call(track.querySelectorAll('[data-packside-carousel-item]'));
      isRtl = getComputedStyle(track).direction === 'rtl';
    }

    function nearestIndex() {
      if (!items.length || !track.clientWidth) return index;

      var trackRect = track.getBoundingClientRect();
      var targetEdge = isRtl ? trackRect.right : trackRect.left;
      var closest = 0;
      var closestDistance = Infinity;

      items.forEach(function (item, itemIndex) {
        var rect = item.getBoundingClientRect();
        var edge = isRtl ? rect.right : rect.left;
        var distance = Math.abs(edge - targetEdge);
        if (distance < closestDistance) {
          closestDistance = distance;
          closest = itemIndex;
        }
      });

      return closest;
    }

    function updateControls() {
      if (!items.length) return;

      var hasOverflow = track.scrollWidth > track.clientWidth + 2;
      if (previous) previous.disabled = !hasOverflow || index <= 0;
      if (next) next.disabled = !hasOverflow || index >= items.length - 1;
      root.classList.toggle('is-overflowing', hasOverflow);
    }

    function syncIndex() {
      if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(function () {
        index = nearestIndex();
        updateControls();
        scrollFrame = null;
      });
    }

    function stopAutoplay() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function startAutoplay() {
      stopAutoplay();
      var autoplayDelay = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
      if (autoplayDelay < 1000 || items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      timer = window.setInterval(function () {
        if (index >= items.length - 1) {
          stopAutoplay();
          return;
        }
        goTo(index + 1, false);
      }, autoplayDelay);
    }

    function goTo(nextIndex, focus) {
      refreshItems();
      if (!items.length) return;

      index = Math.max(0, Math.min(nextIndex, items.length - 1));
      var target = items[index];
      if (target) {
        // Scroll only the carousel's own inline axis. `scrollIntoView()` can
        // move the document vertically when an auto-advance fires below the
        // fold, which makes a homepage appear to scroll by itself.
        var trackRect = track.getBoundingClientRect();
        var targetRect = target.getBoundingClientRect();
        var distance = isRtl ? targetRect.right - trackRect.right : targetRect.left - trackRect.left;
        track.scrollBy({
          left: distance,
          top: 0,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      }
      updateControls();
      if (focus && target && target.focus) target.focus({ preventScroll: true });
    }

    function startDrag(event) {
      if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
      if (track.scrollWidth <= track.clientWidth + 2) return;

      stopAutoplay();
      drag.active = true;
      drag.pointerId = event.pointerId;
      drag.startX = event.clientX;
      drag.lastX = event.clientX;
      drag.moved = false;
      suppressClick = false;
    }

    function moveDrag(event) {
      if (!drag.active || event.pointerId !== drag.pointerId) return;

      var distanceFromStart = event.clientX - drag.startX;
      if (!drag.moved && Math.abs(distanceFromStart) < dragThreshold) return;

      if (!drag.moved && track.setPointerCapture) track.setPointerCapture(event.pointerId);
      drag.moved = true;
      event.preventDefault();

      // Keep the card under the pointer. There is intentionally no edge
      // reordering: reaching an edge is a stable, discoverable end state.
      var delta = event.clientX - drag.lastX;
      /* Carousel drag invariant — keep this physical, not logical:
       * `delta` is the pointer's screen-pixel movement. Always pass `-delta`
       * to scrollBy in both locales; branching on `direction: rtl` reverses
       * the gesture in Chromium/WebKit. Use `isRtl` only for logical edges
       * and indexing, never to change this direct-manipulation mapping. */
      track.scrollBy({ left: -delta, top: 0, behavior: 'auto' });
      drag.lastX = event.clientX;
      track.classList.add('is-dragging');
    }

    function endDrag(event) {
      if (!drag.active || event.pointerId !== drag.pointerId) return;

      if (track.releasePointerCapture && track.hasPointerCapture && track.hasPointerCapture(event.pointerId)) {
        track.releasePointerCapture(event.pointerId);
      }

      var didMove = drag.moved;
      drag.active = false;
      drag.pointerId = null;
      drag.moved = false;
      track.classList.remove('is-dragging');
      syncIndex();
      updateControls();

      if (didMove) {
        suppressClick = true;
        window.setTimeout(function () { suppressClick = false; }, 350);
      }

      startAutoplay();
    }

    refreshItems();
    if (!items.length) return;

    if (previous) {
      previous.addEventListener('click', function () {
        goTo(index - 1, false);
        startAutoplay();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        goTo(index + 1, false);
        startAutoplay();
      });
    }

    track.addEventListener('scroll', syncIndex, { passive: true });
    track.addEventListener('pointerdown', startDrag, { passive: true });
    track.addEventListener('pointermove', moveDrag, { passive: false });
    track.addEventListener('pointerup', endDrag, { passive: true });
    track.addEventListener('pointercancel', endDrag, { passive: true });
    track.addEventListener('dragstart', function (event) { event.preventDefault(); });
    track.addEventListener('click', function (event) {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);
    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', function () {
      if (!root.contains(document.activeElement)) startAutoplay();
    });
    root.addEventListener('pointerdown', stopAutoplay, { passive: true });
    root.addEventListener('pointerup', startAutoplay, { passive: true });
    root.addEventListener('pointercancel', startAutoplay, { passive: true });

    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        refreshItems();
        index = nearestIndex();
        updateControls();
      }).observe(track);
    } else {
      window.addEventListener('resize', function () {
        refreshItems();
        index = nearestIndex();
        updateControls();
      });
    }

    updateControls();
    startAutoplay();
  }

  function init(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(context.querySelectorAll('[data-packside-carousel]'), initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
